import http from "@/settings/apiSettings";

class GES_StocService {
    getStocCurent(data: string, gestiuneId?: string, nivel = 0, includeZero = false): Promise<any> {
        const params: any = { data, nivel, includeZero };
        if (gestiuneId) params.gestiuneId = gestiuneId;
        return http.clientStocuri.get("/GES_Stoc/stoc-curent", { params });
    }

    getDataUltimaInchidere(data: string, gestiuneId?: string, nivel = 0): Promise<any> {
        const params: any = { data, nivel };
        if (gestiuneId) params.gestiuneId = gestiuneId;
        return http.clientStocuri.get("/GES_Stoc/data-ultima-inchidere", { params });
    }

    getMiscari(dataStart: string, dataEnd: string, gestiuneId?: string, nivel = 0): Promise<any> {
        const params: any = { dataStart, dataEnd, nivel };
        if (gestiuneId) params.gestiuneId = gestiuneId;
        return http.clientStocuri.get("/GES_Stoc/miscari", { params });
    }
}

export default new GES_StocService();
